import React from "react";
import { startUploadingLeadFile } from "../assets/helpers/helper";
import moment from "moment-timezone";

class Upload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timeZones: [],
      selectedFile: null,
      csvPreview: null,
      isUploading: false,
      uploadMessage: "",
      errorList: null,
      uploadSuccessful: false
    };
  }

  componentDidMount() {
    console.log(
      "current user time zone...",
      moment.tz.zone(moment.tz.guess()).abbr(360)
    );
    const tempTimeZone = [];
    moment.tz.names().map((element) => {
      const zoneAbbr = moment.tz.zone(element).abbr(360);
      const timeZoneObject = {
        timeZoneAbbr: zoneAbbr,
        timeZone: element
      };
      tempTimeZone.push(timeZoneObject);
    });
    this.setState({
      ...this.state,
      timeZones: [...tempTimeZone]
    });
  }

  handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "text/csv") {
      this.setState({
        selectedFile: file,
        csvPreview: null,
        uploadMessage: "",
        uploadSuccessful: false
      });
    } else {
      this.setState({
        selectedFile: null,
        csvPreview: null,
        uploadMessage: "Please select a valid CSV file",
        uploadSuccessful: false
      });
    }
  };

  previewCSV = () => {
    const { selectedFile } = this.state;
    if (!selectedFile) {
      this.setState({ uploadMessage: "Please select a file first" });
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const csvContent = e.target.result;
      const lines = csvContent.split('\n').filter(line => line.trim() !== '');
      
      // Parse CSV into table data - show all rows
      const tableData = lines.map(line => {
        // Handle CSV parsing with proper comma separation
        const columns = line.split(',').map(col => col.trim().replace(/^"|"$/g, ''));
        return columns;
      });
      
      this.setState({
        csvPreview: tableData,
        uploadMessage: `Preview of all ${tableData.length} rows`
      });
    };
    reader.readAsText(selectedFile);
  };

  uploadCSV = async () => {
    const { selectedFile } = this.state;
    const { user, fetchLeadsOfLoggedinUser, alterComponentSelection } = this.props;
    
    if (!selectedFile) {
      this.setState({ uploadMessage: "Please select a file first" });
      return;
    }

    this.setState({ isUploading: true, uploadMessage: "Uploading..." });

    try {
      const formData = new FormData();
      formData.append("leadFile", selectedFile);
      formData.append("tenant_id", user.tenant_id);
      formData.append("subtenant_id", user.subtenant_id);
      
      const uploadAudioFileResponse = await startUploadingLeadFile(formData);
      
      if (uploadAudioFileResponse.data.message === "success") {
        console.log("uploadAudioFileResponse", uploadAudioFileResponse);
        if (uploadAudioFileResponse.data.error_list.length > 0) {
          this.setState({ 
            errorList: uploadAudioFileResponse.data.error_list,
            isUploading: false,
            uploadMessage: "",
            uploadSuccessful: false
          });
        } else {
          console.log("Upload successful, setting uploadSuccessful to true");
          this.setState({ 
            uploadMessage: "File uploaded successfully!",
            errorList: null,
            isUploading: false,
            uploadSuccessful: true
          }, () => {
            console.log("State updated, uploadSuccessful is now:", this.state.uploadSuccessful);
          });
          // Don't reset selectedFile so buttons remain visible
          this.setState({
            csvPreview: null
          });
        }
      }
    } catch (error) {
      console.error("Upload error:", error);
      this.setState({ uploadMessage: "Upload failed. Please try again." });
    } finally {
      this.setState({ isUploading: false });
    }
  };

  fetchLeadsOfLoggedinUserLeads = async () => {
    // Optionally refresh leads list
    const { user, fetchLeadsOfLoggedinUser, alterComponentSelection } = this.props;
    const fetchLeadsOfLoggedinUserResponse = await fetchLeadsOfLoggedinUser(user.email_id);
    if (fetchLeadsOfLoggedinUserResponse) {
      alterComponentSelection(1);
    }
  };

  setUploadFileProps = async (e) => {
    // This method is kept for backward compatibility but now uses handleFileSelect
    this.handleFileSelect(e);
  };

  render() {
    const { timeZones, selectedFile, csvPreview, isUploading, uploadMessage, errorList, uploadSuccessful } = this.state;
    return (
      <div className="card w-100 d-flex  align-items-center">
        <div className="w-100 card-header rx-card-header">Upload Leads</div>
        <div className="row w-100">
          <div className="col-md-12 row mt-2">
            <div className="col-md-3">Select File</div>
            <div className="col-md-6">
              <input
                onChange={(e) => this.handleFileSelect(e)}
                className="btn form form-control"
                name="leadFile"
                type="file"
                accept=".csv"
              />
            </div>
            <div className="col-md-3 text-end">
              <a
                href={`/a/static/admin/assets/sample_leads.csv`}
                className="btn btn-info btn-sm"
                download
              >
                Download Sample CSV Template
              </a>
            </div>
          </div>
          
          {selectedFile && (
            <div className="col-md-12 row mt-2">
              <div className="col-md-3">Selected File:</div>
              <div className="col-md-9">
                <span className="text-info">{selectedFile.name}</span>
                <div className="mt-2">
                  <button
                    onClick={this.previewCSV}
                    className="btn btn-secondary me-2"
                    disabled={!selectedFile}
                  >
                    Preview CSV
                  </button>
                  <button
                    onClick={this.uploadCSV}
                    className="btn btn-primary me-2"
                    disabled={!selectedFile || isUploading}
                  >
                    {isUploading ? "Uploading..." : "Upload CSV"}
                  </button>
                  <button
                    onClick={() => this.fetchLeadsOfLoggedinUserLeads()}
                    className="btn btn-success"
                  >
                    View Leads
                  </button>
                </div>
              </div>
            </div>
          )}

          {uploadMessage && (
            <div className="col-md-12 row mt-2">
              <div className="col-md-3"></div>
              <div className="col-md-9">
                <div className={`alert ${uploadMessage.includes('successfully') ? 'alert-success' : uploadMessage.includes('error') ? 'alert-warning' : 'alert-info'}`}>
                  {uploadMessage}
                </div>
              </div>
            </div>
          )}

          {errorList && errorList.length > 0 && (
            <div className="col-md-12 row mt-2">
              <div className="col-md-3"></div>
              <div className="col-md-9">
                <div className="alert alert-success">
                  <div className="d-flex align-items-center">
                    <span 
                      className="text-info me-2" 
                      style={{
                        cursor: 'pointer',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        color: '#28a745'
                      }}
                      title={errorList.map((error, index) => 
                        `${index + 1}. ${typeof error === 'string' ? error : JSON.stringify(error)}`
                      ).join('\n')}
                    >
                      ℹ
                    </span>
                    <span><strong>Upload completed with {errorList.length} errors. Hover over the info icon to see details.</strong></span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {csvPreview && (
            <div className="col-md-12 row mt-2">
              <div className="col-md-3">CSV Preview:</div>
              <div className="col-md-9">
                <div className="table-responsive" style={{height: 'calc(100vh - 400px)', overflow: 'auto'}}>
                  <table className="table table-striped table-bordered table-sm">
                    <thead className="table-dark" style={{position: 'sticky', top: 0, zIndex: 1}}>
                      {csvPreview.length > 0 && (
                        <tr>
                          <th scope="col">#</th>
                          {csvPreview[0].map((header, index) => (
                            <th key={index} scope="col">{header}</th>
                          ))}
                        </tr>
                      )}
                    </thead>
                    <tbody>
                      {csvPreview.slice(1).map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          <td className="text-center fw-bold">{rowIndex + 1}</td>
                          {row.map((cell, cellIndex) => (
                            <td key={cellIndex}>{cell}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <small className="text-muted">Showing all {csvPreview.length} rows of CSV data</small>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Upload;
